import type { RefundQuoteData } from './types'

/**
 * A long itinerary is issued as a conjunction ticket, which Sabre's ticket check names
 * "1577543450060/61" while the booking files its taxes and payment under "1577543450060" alone.
 * PLT2867710 (QR) and PLT2645859 (DL): missing their taxes, the YQ/YR came from the fare-rules total
 * instead, which the carrier YQ/YR table cannot see into, and both refunds were quoted ~$850 short.
 */
export function withConjunctionTicketKeys(rqd: RefundQuoteData): RefundQuoteData {
  const renames = (rqd.tickets ?? []).flatMap(ticket => {
    const first = ticket.number.split('/')[0]
    return first !== ticket.number ? [[first, ticket.number] as const] : []
  })
  if (renames.length === 0) return rqd
  return {
    ...rqd,
    allTaxesByTicket: rekeyed(rqd.allTaxesByTicket, renames),
    ticketPayments: rekeyed(rqd.ticketPayments, renames),
  }
}

function rekeyed<T>(byTicket: Record<string, T> | undefined, renames: ReadonlyArray<readonly [string, string]>) {
  if (!byTicket) return byTicket
  const copy = { ...byTicket }
  for (const [first, full] of renames) {
    if (copy[full] !== undefined || copy[first] === undefined) continue
    copy[full] = copy[first]
    delete copy[first]
  }
  return copy
}
